import React from 'react';
import { UserType } from 'src/shared/types';

import styles from './UserTypeTag.module.scss';

type UserTypeTagProps = {
    userType: UserType;
};

const userTypeTagDisplayLabel: Record<UserType, string> = {
    [UserType.INTERNAL]: 'Internal',
    [UserType.EXTERNAL]: 'Customer',
};

/** SCSS uses Internal / Customer suffixes from the previous enum naming. */
const userTypeTagClassSuffix: Record<UserType, string> = {
    [UserType.INTERNAL]: 'Internal',
    [UserType.EXTERNAL]: 'Customer',
};

const UserTypeTag = ({ userType }: UserTypeTagProps) => {
    return (
        <div className={`${styles.userTypeTag} ${styles['userTypeTag' + userTypeTagClassSuffix[userType]]}`}>
            {userTypeTagDisplayLabel[userType]}
        </div>
    );
};

export default UserTypeTag;
